export default "__VITE_ASSET__DFH48bO7__"